import { render, staticRenderFns } from "./infotip-stylized.vue?vue&type=template&id=4b0c3d4e"
import script from "./infotip-stylized.vue?vue&type=script&lang=js"
export * from "./infotip-stylized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports